import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContractNavigationEnum } from 'v3/data/store/contractCard/enum';
import { initialNavigationState } from 'v3/data/store/contractCard/state';
import { contractNavigationSteps } from 'v3/data/store/contractCard/types';

const STEP_INCREMENT = 1;
const FIRST_INDEX = 0;

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState: initialNavigationState,
  reducers: {
    setNavigationStep: (state, action: PayloadAction<ContractNavigationEnum>) => {
      state.currentStep = action.payload;
      return state;
    },
    navigateToNextCard: (state) => {
      const currentIndex = contractNavigationSteps.indexOf(state.currentStep);
      if (currentIndex < contractNavigationSteps.length - STEP_INCREMENT) {
        state.currentStep = contractNavigationSteps[currentIndex + STEP_INCREMENT];
      }
      return state;
    },
    navigateToPreviousCard: (state) => {
      const currentIndex = contractNavigationSteps.indexOf(state.currentStep);
      if (currentIndex > FIRST_INDEX) {
        state.currentStep = contractNavigationSteps[currentIndex - STEP_INCREMENT];
      }
      return state;
    },
  },
});
